import type { GameState, Move, MoveResult } from "../types";
import { applyEndTurn } from "./endTurn";
import { checkVictory } from "./helpers";
import { executeNonTurnMove } from "./runners";
import { validateMove } from "./validate";

export { checkVictory } from "./helpers";

function applyMoveUnchecked(state: GameState, move: Move): MoveResult {
  if (move.type === "endTurn") return applyEndTurn(state);
  const step = executeNonTurnMove(state, move);
  const next = {
    ...step.state,
    status: checkVictory(step.state),
  };
  return { state: next, events: step.events };
}

export function applyMove(state: GameState, move: Move): MoveResult {
  validateMove(state, move);
  return applyMoveUnchecked(state, move);
}

export function applyReplayMove(state: GameState, move: Move): MoveResult {
  return applyMoveUnchecked(state, move);
}
